import React  from 'react';

const CustomCheckbox = (props) => {
  const { name, checked, checkboxText, className } = props;

  return (
    <div className={"custom-control custom-control-alternative custom-checkbox " + className}>
      <input
        className="custom-control-input"
        id={"checkbox-" + name}
        type="checkbox"
        checked={checked}
        onChange={
          (e) => {
            props.onChange(e.target.checked)
          }
        }
        name={name}
      />
      <label
        className="custom-control-label"
        htmlFor={"checkbox-" + name}
      >
          <span className="text-muted">
            { checkboxText }
          </span>
      </label>
    </div>
  );
}

CustomCheckbox.defaultProps = {
  name: '',
  checkboxText: '',
  className: "",
  checked: false,
  onChange: () => {},
};

export { CustomCheckbox };
